import script from "./VIllustration.vue?vue&type=script&setup=true&lang=ts"
export * from "./VIllustration.vue?vue&type=script&setup=true&lang=ts"

import "./VIllustration.vue?vue&type=style&index=0&id=59e29938&lang=scss"

const __exports__ = script;

export default __exports__